import React, { useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Form } from '@unform/web';

import * as Yup from 'yup';

import { Container } from './style';

import { forgotPasswordConfirm as forgotPasswordConfirmService } from 'services/forgot-password';
import HeaderLogo from 'assets/logo.svg';
import InputPassword from 'components/Inputs/InputPassword';
import DefaultButton from 'components/Buttons/DefaultButton';
import BackButton from 'components/Buttons/BackButton';
import DefaultInput from 'components/Inputs/DefaultInput/DefaultInput';

import { resendCode as resendCodeService } from 'services/verifyCode';
import { FormHandles } from '@unform/core';
import getValidationErrors from 'helpers/getValidationErrors';

const schema = Yup.object().shape({
  code: Yup.string().trim().required('Preencha corretamente este campo.'),
  password: Yup.string()
    .trim()
    .required('Preencha corretamente este campo.')
    .min(8, 'A senha deve conter no mínimo 8 caracteres.'),
  passwordConfirmation: Yup.string()
    .oneOf(
      [Yup.ref('password'), null],
      'As senhas informadas não correspondem. Por favor, verifique.',
    )
    .trim()
    .required('Preencha corretamente este campo.'),
});

interface ILocationProps {
  email: string;
}

interface IFormData {
  code: string;
  password: string;
}

const ResetPassword: React.FC = () => {
  const history = useHistory();
  const formRef = useRef<FormHandles>(null);
  const { state } = useLocation<ILocationProps>();
  const { email } = state;

  const resendCode = async () => {
    await resendCodeService({ email });
  };

  const handleSubmit = async (data: IFormData) => {
    const { code, password } = data;

    try {
      formRef.current?.setErrors({});

      await schema.validate(data, { abortEarly: false });

      await forgotPasswordConfirmService({
        code,
        email,
        password,
      }).then(() => {
        history.push('/signIn');
      });
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);

        formRef.current?.setErrors(errors);
      }
    }
  };

  return (
    <Container>
      <div className="return-btn">
        <BackButton />
      </div>

      <img src={HeaderLogo} alt="logo" />

      <h3>Redefinir a senha</h3>

      <p>
        Um código foi enviado para <span>{email}</span>
      </p>

      <Form onSubmit={handleSubmit} ref={formRef}>
        <DefaultInput
          name="code"
          type="text"
          label="Digite o código recebido"
          maxLength={6}
          required
        />
        <InputPassword name="password" label="Nova senha" />
        <InputPassword name="passwordConfirmation" label="Confirmar senha" />

        <p className="resend">
          Não recebeu?{' '}
          <button type="button" onClick={resendCode}>
            Reenviar código
          </button>
        </p>

        <DefaultButton type="submit">Cadastrar</DefaultButton>
      </Form>
    </Container>
  );
};

export default ResetPassword;
